module.exports = __webpack_public_path__ + "static/ymo-all-green-19b78af26446997b0e5c616da6babb45.png";